import { styled } from '@engyalo/design-system';
import { css, Stack } from '@mui/material';

export const NoConversationsWrapper = styled(Stack)(
  () => css`
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    max-height: 70svh;
    gap: 1.2rem;
  `
);
